module.exports = __webpack_public_path__ + "static/media/we-care-about.e978bdc5.jpg";